import { THEME_COLOR } from "../../../styles/colors";

// ---- Display text ----
// Label for the "Add action item" trigger; mirrors agenda's ADD_AGENDA_LABEL.
export const ADD_ACTION_ITEM_LABEL = "Add action item";
export const EMPTY_ACTION_ITEMS_MESSAGE =
  "We'll capture action items as your meeting moves along. You can also add your own for the team at any time.";
export const LOAD_ERROR_MESSAGE = "Unable to load action items";
// Field placeholders for the inline edit card.
export const CONTENT_PLACEHOLDER = "Action item";
export const OWNER_PLACEHOLDER = "Unassigned";
export const DEADLINE_PLACEHOLDER = "TBD";

// Teal accent bar on each action-item tile.
export const ACCENT_COLOR = THEME_COLOR.TEAL_GREEN;

// Fix + tighten the auto-resize content Textarea's height.
// Meridian's auto textarea measures its height with a hidden mirror that uses the
// size-less default text typography (inputText* → falls back to ~16px/24px), while
// the visible text uses textSmall (14px/20px). That mismatch makes the box taller
// than its text (empty gap below). Defining inputTextFontSize/LineHeight aligns the
// mirror to the small text so the box hugs its content; the reduced vertical inset
// trims the remaining top/bottom padding.
export const contentInputTheme = {
  inputTextFontSize: 14,
  inputTextLineHeight: "20px",
  inputSpacingInsetVerticalAuto: 4,
};

// Shared layout for a card's "content + two action icons" top row. Both ActionItemCard (display /
// confirm-delete) and ActionItemEditCard (edit / add) spread this onto their Row so the two icon
// slots land in identical positions across states: slot A (2nd column) holds the primary action
// (edit pencil / save check / confirm-delete trash) and slot B (3rd column) holds the secondary
// action (delete trash / cancel undo), so icons never shift when toggling in and out of edit mode.
export const actionRowLayout = {
  // Tighter gap between the two icon slots so the primary (edit/check) sits closer to the
  // secondary (delete/undo); content fills, so this pulls the icons together at the right edge.
  spacing: "none",
  // Center the icons vertically against the content so they sit mid-row in every state.
  alignmentVertical: "center",
  widths: ["fill", "fit", "fit"],
};

